import { fetchAddressById, fetchStreetSuggestions } from '../api/autocomplete-fetchers.js';
import { fetchSearchSuggestions } from '../api/search-fetchers.js';
import { fetchFalckdkApi } from '../utils/fetch.js';

export async function completeaddress(addressEl, addressIdEl, outputEl, validator, id, addressOutput) {
    $('#' + outputEl)
        .find('button')
        .on('click', removeAddressFromClick);

    $('#' + addressEl).autocomplete({
        async source(request, response) {
            const data = await fetchStreetSuggestions(request.term);

            response(data);
        },
        minLength: 3,
        select: handleCallback,
        change: handleChangeCallback,
    });

    if (id && addressOutput) {
        setOutputAddress(id, addressOutput);
    } else if ($('#' + addressIdEl)[0]?.value && $('#' + addressIdEl)[0]?.value !== '') {
        const address = await fetchAddressById($('#' + addressIdEl)[0].value);

        addAddress(address);
    }

    function handleChangeCallback(event, ui) {
        let lookupAddress = false;

        if (!ui.item) {
            lookupAddress = true;
        }

        if (lookupAddress) {
            $('#' + addressEl).autocomplete('search');
        }
    }

    function handleCallback(event, ui) {
        if (ui.item === null) {
            removeAddress();
        } else {
            addAddress(ui.item);
        }
    }

    function addAddress(addressObject) {
        let prettyAddress = addressObject.streetname + ' ' + addressObject.housenumber;

        if (addressObject.floor) {
            prettyAddress += ', ' + addressObject.floor;
        }
        if (addressObject.door) {
            prettyAddress += ' ' + addressObject.door;
        }
        prettyAddress += '\n';
        prettyAddress += addressObject.postcode + ' ' + addressObject.city;

        setOutputAddress(addressObject.id, prettyAddress);
    }

    function removeAddressFromClick() {
        $('#' + addressEl).val('');
        setOutputAddress('', '');
    }

    function removeAddress() {
        setOutputAddress('', '');
    }

    function setOutputAddress(id, addressOutput) {
        addressOutput = addressOutput.replace('<br>', '\n');
        $('#' + addressIdEl).val(id);
        $('#' + outputEl)
            .find('.address-output')
            .text(addressOutput);

        if (id) {
            $('#' + outputEl).hide();
            $('#' + addressEl).show();
            $('#' + addressEl).focus();
        } else {
            $('#' + outputEl).show();
            $('#' + addressEl).hide();
        }
        if (validator === 'jquery') {
            $('#' + addressIdEl).valid();
        } else {
            Foundation.libs.abide.validate($('#' + addressIdEl).get(), { type: 'input' }, false);
        }
    }
}

export function completecity(postcode, city) {
    $('#' + postcode).autocomplete({
        async source(request, response) {
            const data = await fetchCitySuggestions(request.term);
            const mappedData = data.map((value) => ({
                label: value.Postcode + ' ' + value.City,
                value: value.Postcode,
                city: value.City,
            }));

            response(mappedData);
        },
        select(event, ui) {
            $('#' + city).val(ui.item.city);
            $('#' + city)
                .parents('.checkout-form-group')
                .addClass('is-filled');
            Foundation.libs.abide.validate($('#' + city).get(), { type: 'input' }, false);
        },
        async change(event, ui) {
            const post = $('#' + postcode).val();

            if (ui.item === null) {
                $('#' + city).val('');
                $('#' + city)
                    .parents('.checkout-form-group')
                    .removeClass('is-filled');
            } else {
                $('#' + city).val(ui.item.city);
            }

            if (post.length === 4) {
                const data = await fetchCitySuggestions(post);

                if (data.length === 1) {
                    $('#' + city).val(data[0].City);
                    Foundation.libs.abide.validate($('#' + city).get(), { type: 'input' }, false);
                }
            }
        },
    });
}

async function fetchCitySuggestions(term) {
    try {
        const fetchResponse = await fetchFalckdkApi('/api/Autocomplete/City', {
            params: {
                term,
            },
            method: 'GET',
        });

        return fetchResponse.json();
    } catch (error) {
        console.error('Error fetching city suggestions:', error);
    }
}

export function completsugestionsBody(term, suggestionClickCallback) {
    $('.' + term)
        .autocomplete({
            async source(request, response) {
                const data = await fetchSearchSuggestions(request.term);

                const mappedData = data.map((item) => ({
                    label: item,
                }));

                response(mappedData);
            },
            minLength: 3,
            select(event, ui) {
                $('.' + term).val(ui.item.value);
                $('#searchform').submit();
            },
            appendTo: '.site-search-container__autocomplete-body',
        })
        .keyup((e) => {
            if (e.which === 13) {
                $('.ui-menu-item').hide();
            }
        });

    $.ui.autocomplete.prototype._renderItem = function (ul, item) {
        return $('<li></li>')
            .data('item.autocomplete', item)
            .append('<span>' + item.label + '</span>')
            .on('click', () => suggestionClickCallback?.(item))
            .appendTo(ul);
    };
}
